import { Component, OnInit } from '@angular/core';
import { Router, RouterOutlet } from '@angular/router';
import { LandingComponent } from '../../pages/landing-sheet/landing/landing.component';
import { NgIf } from '@angular/common';
import { SelectedWorkspaceStore } from '../../stores/selected-workspace.store';
import { firstValueFrom } from 'rxjs';
import { ShowLandingService } from '../../shared/services/show-landing.service';

@Component({
  selector: 'app-default-proxy',
  standalone: true,
  imports: [RouterOutlet, LandingComponent, NgIf],
  templateUrl: './default-proxy.component.html',
  styleUrl: './default-proxy.component.less',
})
export class DefaultProxyComponent implements OnInit {
  constructor(
    public selectedWorkspace: SelectedWorkspaceStore,
    private router: Router,
    public showLanding: ShowLandingService,
  ) {}

  ngOnInit() {
    this.showLanding.setIsLandingShowed(true);

    firstValueFrom(this.selectedWorkspace.user$).then((user) => {
      if (user) {
        this.router.navigate(['projects'], { replaceUrl: true });
        this.showLanding.setIsLandingShowed(false);
      }
    });
  }
}
